<template>
  <div style="margin:5px; width: 100%;" v-if="tableData.length > 0">
    <!-- <span style="width: 100%;"> -->
    <b-modal
      id="file_working-modal"
      v-model="showFileModal"
      centered
      scrollable
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Getting File"
      :header-text-variant="'light'">
      Working on file. Please wait...
      <b-button class="mt-3" block @click="showFileModal = !showFileModal">OK</b-button>
    </b-modal>
    <span v-if="type == 'summary'">
      <div class="table-head">
        {{objectName}} Objects to be Created: {{ tableData.length }}
        <i
          class="fa fa-download"
          style="right: 30px; cursor: pointer;"
          title="Download CSV"
          @click="downloadCSV(tableData, objectName + '_summary')"
        ></i>
      </div>
    </span>
    <span v-if="type == 'error'">
      <div class="error-table-head">
        Errors in the file data: {{ tableData.length }}
        <i
          class="fa fa-download"
          style="right: 30px; cursor: pointer;"
          title="Download CSV"
          @click="downloadCSV(tableData, 'error_summary')"
        ></i>
      </div>
    </span>
    <span v-if="type == 'warning'">
      <div class="warning-table-head cursor-pointer">
        Please take note of these invalid DOI values: {{ tableData.length }}
        <i
          class="fa fa-download"
          style="right: 30px; cursor: pointer;"
          title="Download CSV"
          @click="downloadCSV(tableData, '_warnings')"
        ></i>
      </div>
    </span>
    <!-- <span style="margin-left: 5px; margin-top: 0px;"> -->
    <b-table 
      ref="my-table"
      striped 
      hover 
      sticky-header="500px"
      responsive
      selectable
      select-mode='single'
      bordered
      head-variant="light"
      no-border-collapse
      :items="items"
      :fields="fields_arr"
      tbody-tr-class="vt-table-row"
      style="position:relative; left:15px;"
      class="row"
    >
      <template v-slot:head()="field">
          <span :title="field.field.title" style="font-size: small; white-space: nowrap;">
              {{ field.label }}
          </span>
      </template>
      <!-- Add tooltips -->
      <template v-slot:cell()="data">
        <span  :title='data.value'>{{ data.value}}</span>
      </template>
    </b-table>
    <!-- </span> -->
    <!-- <b-overlay :show="isBusy" no-wrap opacity="0.5"></b-overlay> -->
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "VBUploadObjectsTable",
  components: {

  },
  computed: {},
  watch: {
    /* Optionally hide scrollbar when loading */
    isBusy(newVal, oldVal) {
      if (newVal !== oldVal) {
        const tableScrollBody = this.$refs["my-table"].$el;
        if (newVal === true) {
          tableScrollBody.classList.add("overflow-hidden");
        } else {
          tableScrollBody.classList.remove("overflow-hidden");
        }
      }
    }
  },
  props: {
    tableData: Array,
    objectName: String,
    type: String,
    fields: {
      type: Array,
      default: null
    }
  },
  created() {
    this.fetchItems();
  },
  mounted() {
    const tableScrollBody = this.$refs["my-table"].$el;
    /* Consider debouncing the event call */
    tableScrollBody.addEventListener("scroll", this.onScroll);
    // Only build fields if they weren't provided as a prop
    if (!this.fields) {
      this.fields_arr = this.buildFieldsArray(this.tableData);
    }else{
      this.fields_arr = this.fields;
    }
  },
  beforeDestroy() {
    /* Clean up just to be sure */
    const tableScrollBody = this.$refs["my-table"].$el;
    tableScrollBody.removeEventListener("scroll", this.onScroll);
  },
  data(){
    return{
      showFileModal: false,
      items: [],
      currentPage: 0,
      perPage: 50,
      totalItems: this.tableData.length,
      isBusy: false,
      fields_arr: []
    };
  },
  methods: {
    buildFieldsArray(data) {
      // Gets called by the onUpload() method. Build the fields array which is used by the main b-table.

      // NOTE: IF THERE ARE NO ROWS IN DATA, THIS WILL ERROR OUT.
      // TODO: handle no rows in input. Currently, we are checking that there are rows before calling this
      // function in myProvider().

      // convert each element to an object containing the field name as a key, a sortable key, and tdclass:
      // ie. convert "OriginalID" to 
      // "{ key: 'OriginalID', sortable: true, tdClass: 'text-truncate vt-table-cell' },"
      let field_list = Object.keys(data[0]);

      let field_array = [];

      field_list.forEach(function(fieldName) {
        let field_dict = {};
        field_dict['key'] = fieldName;
        field_dict['sortable'] = true;
        field_dict['tdClass'] = 'text-truncate vt-table-cell';
        field_dict['__rowVariant'] = 'danger';

        field_array.push(field_dict);
      });

      return field_array;
    },
    downloadCSV: function (items, title) {
      this.showFileModal = true;
      var columns = _.keys(items[0]);
      var csv = columns.join(",") + "\n";
      items.forEach(function (row) {
        csv += _.values(row).join(",");
        csv += "\n";
      });
      this.showFileModal = false;
      var hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
      hiddenElement.target = "_blank";
      hiddenElement.download = title + ".csv";
      hiddenElement.click();
    },
    async fetchItems() {
        /* No need to call if all items retrieved */
        if (this.items.length === this.totalItems) return;

        /* Enable busy state */
        this.isBusy = true;

        let start = this.currentPage * this.perPage;
        let end = start + this.perPage;

        /* Get new items */
        const newItems = this.tableData.slice(start, end);

        /* Increment current page */
        this.currentPage++;

        /* Add new items to existing ones */
        this.items = this.items.concat(newItems);

        /* Disable busy state */
        this.isBusy = false;
    },
    onScroll(event) {
      if (
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight
      ) {
        if (!this.isBusy) {
          this.fetchItems();
        }
      }
    }
  }
};
</script>

<style scoped>
  .table-head {
    background: #777;
    color: white;
    font-weight: bold;
    text-align: left;
    padding: 5px;
  }

  .error-table-head {
    background: red;
    color: white !important;
    font-weight: bold;
    text-align: left;
    padding: 5px;
  }

  .warning-table-head {
    background: rgb(226, 178, 57);
    color: white !important;
    font-weight: bold;
    text-align: left;
    padding: 5px;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>